import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../../common/store/generic.selectors';
import { ListItem } from '../../typeahead/types';
import {
  AttendanceRegularityModel,
  userWorkAttendanceFeatureKey,
} from './types';
import { IUserWorkAttendanceState } from './user-work-attendance.reducer';

const userWorkAttendanceFeatureState =
  createFeatureSelector<IUserWorkAttendanceState>(userWorkAttendanceFeatureKey);

export const userWorkAttendanceSelectors = {
  getRegularity: createApiCallSelectors<
    AttendanceRegularityModel,
    IUserWorkAttendanceState
  >(userWorkAttendanceFeatureState, 'getRegularity'),
  getUsers: createApiCallSelectors<ListItem[], IUserWorkAttendanceState>(
    userWorkAttendanceFeatureState,
    'getUsers',
  ),
  getSalesPersonRegularity: createApiCallSelectors<
    AttendanceRegularityModel,
    IUserWorkAttendanceState
  >(userWorkAttendanceFeatureState, 'getSalesPersonRegularity'),
  getSalesPersonUsers: createApiCallSelectors<
    ListItem[],
    IUserWorkAttendanceState
  >(userWorkAttendanceFeatureState, 'getSalesPersonUsers'),
};
